import { scrollToTop } from '@/shared/utils/scrollBehavior';

export default defineNuxtPlugin(() => {
  const router = useRouter();

  router.afterEach((to, from) => {
    if (to.path !== from.path) {
      nextTick(() => {
        scrollToTop('smooth');
      });
    }
  });
});
